import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ArquivoValidator {

  static tamanhoMaximo(ac: AbstractControl): ValidationErrors | null {

    return ac.value && ac.value.size >= 4000000 ? { tamanhoMaximo: true } : null;

  }

  static somentePdf(ac: AbstractControl): ValidationErrors | null {

    return ac.value && ac.value.type !== 'application/pdf' ? { somentePdf: true } : null;

  }

}
